module.exports = __webpack_public_path__ + "img/androidTip.cd65a33f.png";